export interface VideoItem {
  id: string;
  title: string;
  description: string;
  category: string;
  thumbnail: string;
  duration: string;
  quality: string;
  views: number;
  rating: number;
  date: string;
  author: string;
  tags: string[];
  content: string;
}

export const videos: VideoItem[] = [
  {
    id: 'v001',
    title: '探索宇宙奥秘：从银河系到深空',
    description: '跟随顶尖天文学家一起，深入探索浩瀚宇宙的壮丽景象与未解之谜，从太阳系到遥远的星系团，感受宇宙的无限魅力。',
    category: 'jilupian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Stunning%20deep%20space%20galaxy%20with%20vibrant%20nebula%20colors%2C%20scientific%20documentary%20style%2C%20cinematic%20lighting%2C%20stars%20and%20cosmic%20dust%2C%20clean%20dark%20background%2C%20high%20resolution%20astrophotography%20aesthetic&width=800&height=450&seq=video-v001&orientation=landscape',
    duration: '48:32',
    quality: '4K',
    views: 128500,
    rating: 4.8,
    date: '2026-07-15',
    author: '深空探索工作室',
    tags: ['宇宙', '天文', '科学', '纪录片'],
    content: '<p>从古至今，人类对宇宙的好奇从未停歇。这部纪录片带领观众踏上一段跨越时空的宇宙探索之旅。从我们熟悉的太阳系开始，到银河系的中心黑洞，再到遥远的河外星系，每一个画面都令人叹为观止。</p><p>本片汇集了哈勃望远镜、韦伯太空望远镜等顶尖天文设备拍摄的真实影像，配合深入浅出的科学解说，让普通观众也能领略宇宙的壮美与神秘。</p><p>影片特别关注了近年来天文学的重大发现，包括引力波的探测、系外行星的搜寻，以及暗物质和暗能量的最新研究进展。</p>',
  },
  {
    id: 'v002',
    title: '人工智能重塑未来：2026科技趋势深度解读',
    description: '行业专家深度剖析AI技术如何改变各行各业，从医疗到教育，从金融到制造业，洞见未来科技发展方向。',
    category: 'keji',
    thumbnail: 'https://readdy.ai/api/search-image?query=Futuristic%20AI%20technology%20visualization%20with%20neural%20network%20patterns%2C%20clean%20modern%20aesthetic%2C%20soft%20warm%20lighting%2C%20minimalist%20tech%20design%2C%20data%20visualization%20elements%2C%20professional%20presentation%20style&width=800&height=450&seq=video-v002&orientation=landscape',
    duration: '35:18',
    quality: '4K',
    views: 95600,
    rating: 4.7,
    date: '2026-07-20',
    author: '科技视界',
    tags: ['人工智能', '科技', '趋势', '深度解读'],
    content: '<p>2026年，人工智能技术正以前所未有的速度改变着我们的世界。本视频邀请多位行业领军人物，深入探讨AI在医疗诊断、自动驾驶、金融风控、智能制造等领域的最新应用。</p><p>从大语言模型的进化到具身智能的突破，从AI伦理的讨论到人机协作的未来，每个话题都与我们的日常生活息息相关。</p><p>无论你是科技从业者还是普通观众，这部视频都能帮你建立起对AI技术发展的全面认知。</p>',
  },
  {
    id: 'v003',
    title: '大师电影课：镜头语言与叙事艺术',
    description: '奥斯卡获奖导演亲授电影制作精髓，从分镜设计到后期剪辑，系统掌握视觉叙事的核心技法。',
    category: 'yingshi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20director%20working%20on%20set%20with%20professional%20camera%2C%20warm%20cinematic%20lighting%2C%20movie%20production%20atmosphere%2C%20artistic%20composition%2C%20film%20making%20education%20style&width=800&height=450&seq=video-v003&orientation=landscape',
    duration: '62:45',
    quality: '4K',
    views: 72300,
    rating: 4.9,
    date: '2026-06-28',
    author: '光影学院',
    tags: ['电影', '导演', '拍摄', '教程'],
    content: '<p>这是一堂不可多得的电影大师课。由获得多项国际大奖的资深导演亲自授课，从剧本分析、分镜设计、镜头调度到后期剪辑，全方位讲解电影叙事的核心技法。</p><p>课程中包含了大量经典电影片段的分析解读，以及实际拍摄现场的幕后花絮，让学习者能够直观理解每一个创作决策背后的思考。</p><p>适合电影爱好者、影视专业学生以及有志于从事影视创作的从业者观看学习。</p>',
  },
  {
    id: 'v004',
    title: '全球美食之旅：亚洲街头小吃大赏',
    description: '跟随美食家环游亚洲，探索各地最具特色的街头美食，品味地道的异域风味与饮食文化。',
    category: 'shenghuo',
    thumbnail: 'https://readdy.ai/api/search-image?query=Vibrant%20Asian%20street%20food%20market%20with%20colorful%20dishes%2C%20steaming%20hot%20food%20stalls%2C%20warm%20evening%20lighting%2C%20rich%20textures%20and%20authentic%20atmosphere%2C%20food%20documentary%20style%20photography&width=800&height=450&seq=video-v004&orientation=landscape',
    duration: '41:20',
    quality: '1080P',
    views: 187200,
    rating: 4.6,
    date: '2026-07-08',
    author: '味蕾漫游',
    tags: ['美食', '旅行', '亚洲', '文化'],
    content: '<p>从曼谷的唐人街到东京的筑地市场，从台北的士林夜市到新加坡的牛车水，这部纪录片带你领略亚洲最地道、最精彩的街头美食文化。</p><p>每一集都聚焦一座城市的特色小吃，不仅有令人垂涎的美食特写，更有摊主们背后的故事和代代相传的烹饪技艺。</p><p>看完美食纪录片，你会对亚洲饮食文化的博大精深有全新的认识。</p>',
  },
  {
    id: 'v005',
    title: '高效学习法：如何用20小时掌握任何新技能',
    description: '基于认知科学的学习效率提升指南，帮你打破学习瓶颈，用科学方法快速掌握新知识和技能。',
    category: 'jiaoyu',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20study%20space%20with%20laptop%20and%20notebooks%2C%20warm%20natural%20light%2C%20organized%20desk%2C%20learning%20and%20education%20concept%2C%20clean%20aesthetic%2C%20soft%20shadows%2C%20productive%20atmosphere&width=800&height=450&seq=video-v005&orientation=landscape',
    duration: '28:15',
    quality: '1080P',
    views: 215400,
    rating: 4.8,
    date: '2026-07-25',
    author: '知行学院',
    tags: ['学习方法', '效率', '认知科学', '自我提升'],
    content: '<p>你是否曾因为觉得某项技能太难而放弃学习？这部视频将彻底改变你对学习的认知。基于认知心理学和行为科学的最新研究成果，我们总结了一套高效的学习方法论。</p><p>从目标拆解、刻意练习到反馈循环，每一个步骤都有科学依据支撑。无论你想学一门新语言、一项乐器还是编程技能，这套方法都能帮你事半功倍。</p><p>视频中包含了多个真实案例，展示了普通人如何在短时间内掌握看似困难的技能。</p>',
  },
  {
    id: 'v006',
    title: '爆笑合集：年度最搞笑综艺名场面',
    description: '精选全年综艺节目中最令人捧腹的经典片段，笑点密集不间断，治愈你的不开心。',
    category: 'yule',
    thumbnail: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20comedy%20show%20stage%20with%20warm%20spotlights%2C%20entertaining%20atmosphere%2C%20laughter%20and%20joy%2C%20variety%20show%20aesthetic%2C%20vibrant%20colors%2C%20energetic%20mood%2C%20professional%20studio%20lighting&width=800&height=450&seq=video-v006&orientation=landscape',
    duration: '55:40',
    quality: '1080P',
    views: 342100,
    rating: 4.5,
    date: '2026-07-30',
    author: '欢乐制造机',
    tags: ['综艺', '搞笑', '合集', '娱乐'],
    content: '<p>生活需要笑声，这部合集就是你的欢乐源泉。我们精心挑选了2026年上半年最火爆的综艺名场面，从脱口秀到真人秀，从访谈节目到竞技综艺，每一段都能让你开怀大笑。</p><p>不仅有国内综艺的经典片段，还收录了部分国外热门节目的精彩剪辑。无论你是什么笑点类型，总有一段能戳中你。</p><p>适合在压力大的时候观看，保证让你心情愉悦！</p>',
  },
  {
    id: 'v007',
    title: '古典音乐入门：从巴赫到贝多芬',
    description: '零基础也能听懂的古典音乐赏析课程，带你走进交响乐的宏伟殿堂，感受经典旋律的不朽魅力。',
    category: 'yinyue',
    thumbnail: 'https://readdy.ai/api/search-image?query=Elegant%20classical%20music%20concert%20hall%20with%20orchestra%2C%20warm%20golden%20lighting%2C%20grand%20piano%2C%20sophisticated%20atmosphere%2C%20musical%20instruments%2C%20refined%20classical%20aesthetic&width=800&height=450&seq=video-v007&orientation=landscape',
    duration: '72:10',
    quality: '4K',
    views: 56800,
    rating: 4.9,
    date: '2026-06-15',
    author: '音悦人生',
    tags: ['古典音乐', '交响乐', '音乐赏析', '入门'],
    content: '<p>古典音乐并不遥远，它就在我们身边。这部视频课程专为零基础的音乐爱好者设计，用最通俗易懂的语言，带你走进古典音乐的殿堂。</p><p>从巴洛克时期的巴赫、维瓦尔第，到古典时期的莫扎特、海顿，再到浪漫时期的贝多芬、肖邦，每一段音乐都有其独特的时代背景和情感表达。</p><p>课程配有大量经典曲目的演奏视频片段，让你在欣赏美妙音乐的同时，理解作品背后的故事和创作技法。</p>',
  },
  {
    id: 'v008',
    title: '深海探险：马里亚纳海沟的秘密',
    description: '跟随深海探测器下潜万米，揭秘地球最深处马里亚纳海沟的神奇生态与地质奇观。',
    category: 'jilupian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Mysterious%20deep%20ocean%20with%20bioluminescent%20creatures%2C%20dark%20blue%20underwater%20scene%2C%20submarine%20exploring%20abyss%2C%20scientific%20documentary%20style%2C%20ethereal%20lighting%2C%20deep%20sea%20atmosphere&width=800&height=450&seq=video-v008&orientation=landscape',
    duration: '52:30',
    quality: '4K',
    views: 89400,
    rating: 4.7,
    date: '2026-07-05',
    author: '深空探索工作室',
    tags: ['海洋', '探险', '科学', '纪录片'],
    content: '<p>地球最深的地方——马里亚纳海沟，深度超过11000米，水压高达1000个大气压。在这样的极端环境下，竟然存在着一个我们几乎完全不了解的生态系统。</p><p>本片记录了科考团队使用最新深海探测技术，首次近距离拍摄到海沟深处的奇异生物和地质构造。从透明的深海鱼类到依靠化学合成生存的微生物群落，每一个发现都令人惊叹。</p><p>这不仅是一次科学探险，更是对人类探索精神的致敬。</p>',
  },
  {
    id: 'v009',
    title: '日语零基础快速入门：30天开口说',
    description: '专业日语教师精心设计的速成课程，从五十音到日常对话，30天让你自信开口说日语。',
    category: 'jiaoyu',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20Japanese%20language%20learning%20scene%20with%20textbooks%20and%20cultural%20elements%2C%20cherry%20blossom%20theme%2C%20warm%20natural%20light%2C%20clean%20minimalist%20design%2C%20educational%20atmosphere&width=800&height=450&seq=video-v009&orientation=landscape',
    duration: '38:45',
    quality: '1080P',
    views: 167800,
    rating: 4.6,
    date: '2026-07-18',
    author: '知行学院',
    tags: ['日语', '语言学习', '入门', '速成'],
    content: '<p>想去日本旅行但担心语言不通？喜欢动漫日剧想听懂原声？这个30天日语速成课程就是为你准备的。</p><p>课程由资深日语教师设计，采用"场景化学习法"，每天学习一个实用场景的对话。从机场入境到餐厅点餐，从购物砍价到问路求助，覆盖了旅行中所有高频场景。</p><p>只需每天投入30分钟，30天后你就能进行基础的日语日常对话。课程还配有发音纠正和听力训练模块，确保你学到的不仅是哑巴日语。</p>',
  },
  {
    id: 'v010',
    title: '数码评测：2026年度旗舰手机横评',
    description: '六大品牌旗舰手机全面对比评测，从性能跑分到实拍样张，帮你做出最明智的购机选择。',
    category: 'keji',
    thumbnail: 'https://readdy.ai/api/search-image?query=Premium%20smartphones%20lined%20up%20on%20a%20clean%20minimalist%20surface%2C%20modern%20tech%20review%20setting%2C%20soft%20studio%20lighting%2C%20professional%20product%20photography%2C%20sleek%20design%20aesthetic&width=800&height=450&seq=video-v010&orientation=landscape',
    duration: '45:20',
    quality: '4K',
    views: 203500,
    rating: 4.5,
    date: '2026-08-01',
    author: '科技视界',
    tags: ['手机', '评测', '数码', '对比'],
    content: '<p>2026年旗舰手机市场竞争空前激烈。我们拿到了六大品牌的最新旗舰机型，从外观设计、屏幕显示、性能跑分、影像系统到续航充电，进行了全方位无死角的对比评测。</p><p>特别是影像系统，我们在相同场景下拍摄了大量对比样张，让你直观看到每台手机的真实拍照水平。视频中还包含了慢动作、夜景、人像等专项测试。</p><p>无论你是参数党还是实用派，看完这部横评视频，你一定能找到最适合自己的那台手机。</p>',
  },
  {
    id: 'v011',
    title: '经典电影重温：《肖申克的救赎》深度解析',
    description: '影史经典之作的全面解读，从主题隐喻到镜头语言，挖掘这部不朽佳作背后的深层含义。',
    category: 'yingshi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cinematic%20prison%20scene%20with%20dramatic%20lighting%2C%20hope%20and%20freedom%20theme%2C%20rain%20scene%2C%20emotional%20atmosphere%2C%20classic%20film%20aesthetic%2C%20warm%20golden%20light%20breaking%20through%20darkness&width=800&height=450&seq=video-v011&orientation=landscape',
    duration: '38:15',
    quality: '1080P',
    views: 91500,
    rating: 4.9,
    date: '2026-06-20',
    author: '光影学院',
    tags: ['电影', '解析', '经典', '影评'],
    content: '<p>《肖申克的救赎》常年位居各大影评网站榜首，但你真的看懂了吗？这部深度解析视频将带你重新审视这部影史经典。</p><p>从安迪入狱的第一天到他最终越狱重获自由，每一个镜头、每一句台词都蕴含着导演的精心设计。我们逐帧分析了影片中最关键的几个场景，揭示那些你可能忽略的细节和隐喻。</p><p>希望、自由、体制化——这些宏大的主题如何通过一个小小监狱中的故事被完美呈现？答案就在这部解析视频中。</p>',
  },
  {
    id: 'v012',
    title: '瑜伽入门：30天身心蜕变计划',
    description: '专业瑜伽导师带领的零基础入门课程，每天20分钟，30天改善体态、缓解压力、重塑身心平衡。',
    category: 'shenghuo',
    thumbnail: 'https://readdy.ai/api/search-image?query=Peaceful%20yoga%20studio%20with%20natural%20light%2C%20minimalist%20zen%20atmosphere%2C%20warm%20wooden%20floors%2C%20plants%20and%20meditation%20elements%2C%20wellness%20lifestyle%20aesthetic&width=800&height=450&seq=video-v012&orientation=landscape',
    duration: '32:40',
    quality: '1080P',
    views: 134600,
    rating: 4.7,
    date: '2026-07-12',
    author: '身心之旅',
    tags: ['瑜伽', '健身', '入门', '健康'],
    content: '<p>不需要任何瑜伽基础，不需要柔韧性好，甚至不需要瑜伽垫之外的任何器材。这个30天瑜伽入门计划就是为忙碌的现代人设计的。</p><p>每天只需20分钟，从最基础的呼吸法和山式站立开始，循序渐进地学习各种体式。课程特别注重正确的姿势和呼吸配合，避免初学者常见的受伤风险。</p><p>30天后，你不仅会看到体态和气质的明显改善，更重要的是，你会找到一种属于自己的身心放松方式。</p>',
  },
  {
    id: 'v013',
    title: '进击的巨人：从漫画到动画的传奇之路',
    description: '回顾《进击的巨人》从连载到完结的完整历程，解析其独特的世界观建构与深刻主题表达。',
    category: 'donghua',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20anime%20style%20colossal%20titan%20scene%20with%20dramatic%20sky%2C%20intense%20action%20atmosphere%2C%20detailed%20illustration%20style%2C%20warm%20orange%20and%20dark%20tones%2C%20cinematic%20animation%20aesthetic&width=800&height=450&seq=video-v013&orientation=landscape',
    duration: '56:20',
    quality: '1080P',
    views: 278300,
    rating: 4.8,
    date: '2026-07-22',
    author: '二次元研究所',
    tags: ['动漫', '进击的巨人', '解析', '动画'],
    content: '<p>《进击的巨人》无疑是21世纪最具影响力的动漫作品之一。从2009年漫画连载开始，到2023年动画最终季完结，这部作品陪伴了一代人的成长。</p><p>本视频全面回顾了巨人的完整故事线，深入分析其独特的世界观设定——从帕拉迪岛的城墙到马莱帝国的政治，从艾尔迪亚人的历史到始祖尤米尔的真相。</p><p>更重要的是，我们探讨了这部作品所触及的深刻主题：自由的代价、战争的本质、仇恨的循环。这些思考让《进击的巨人》远不止是一部热血战斗番。</p>',
  },
  {
    id: 'v014',
    title: '钢琴入门教程：从零开始学弹奏',
    description: '音乐学院专业教师录制的钢琴零基础教程，从识谱到手型，30节课学会弹奏你喜爱的曲子。',
    category: 'yinyue',
    thumbnail: 'https://readdy.ai/api/search-image?query=Elegant%20grand%20piano%20in%20a%20bright%20room%20with%20sheet%20music%2C%20warm%20natural%20light%2C%20classical%20music%20atmosphere%2C%20educational%20setting%2C%20refined%20aesthetic&width=800&height=450&seq=video-v014&orientation=landscape',
    duration: '68:30',
    quality: '4K',
    views: 89200,
    rating: 4.8,
    date: '2026-06-25',
    author: '音悦人生',
    tags: ['钢琴', '音乐', '教程', '入门'],
    content: '<p>你是否曾经梦想过坐在钢琴前，指尖流淌出美妙的旋律？这个钢琴入门教程就是为怀揣音乐梦想的你准备的。</p><p>课程由音乐学院专业教师录制，采用"学练结合"的教学方法。每节课先讲解乐理知识和演奏技巧，然后示范演奏，最后布置练习任务。从认识五线谱到正确的手型姿势，从单音练习到双手合奏，每一步都有详细的讲解和示范。</p><p>30节课后，你将能够独立演奏《致爱丽丝》、《梦中的婚礼》等经典曲目，为后续更深入的学习打下坚实基础。</p>',
  },
  {
    id: 'v015',
    title: '鬼灭之刃：现象级动漫的幕后故事',
    description: '揭秘《鬼灭之刃》从漫画到动画化的全过程，深入了解这部现象级作品的制作秘辛与成功之道。',
    category: 'donghua',
    thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20demon%20slayer%20style%20scene%20with%20water%20breathing%20effects%2C%20Japanese%20traditional%20elements%2C%20warm%20sunset%20lighting%2C%20dynamic%20action%20composition%2C%20stunning%20animation%20aesthetic&width=800&height=450&seq=video-v015&orientation=landscape',
    duration: '44:15',
    quality: '1080P',
    views: 356700,
    rating: 4.7,
    date: '2026-07-28',
    author: '二次元研究所',
    tags: ['动漫', '鬼灭之刃', '幕后', '制作'],
    content: '<p>《鬼灭之刃》剧场版无限列车篇曾创下日本影史票房纪录，TV动画更是风靡全球。这部看似普通的少年漫画，为何能取得如此惊人的成功？</p><p>本视频独家采访了动画制作团队的核心成员，从原画绘制、声优配音到音乐制作，全方位揭秘《鬼灭之刃》的创作过程。特别是ufotable工作室那令人惊叹的作画水准背后，是制作团队无数个不眠之夜的付出。</p><p>无论你是不是鬼灭的粉丝，这个关于匠心与热爱的故事都值得一看。</p>',
  },
  {
    id: 'v016',
    title: '地球脉动：亚马逊雨林的生命奇迹',
    description: '深入亚马逊雨林腹地，探秘地球上生物多样性最丰富的生态系统，感受大自然的壮丽与脆弱。',
    category: 'jilupian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Lush%20Amazon%20rainforest%20with%20sunlight%20streaming%20through%20canopy%2C%20vibrant%20green%20vegetation%2C%20exotic%20wildlife%2C%20nature%20documentary%20style%2C%20ethereal%20atmosphere%2C%20biodiversity%20showcase&width=800&height=450&seq=video-v016&orientation=landscape',
    duration: '58:00',
    quality: '4K',
    views: 112300,
    rating: 4.9,
    date: '2026-07-10',
    author: '深空探索工作室',
    tags: ['自然', '亚马逊', '生态', '纪录片'],
    content: '<p>亚马逊雨林被称为"地球之肺"，这里孕育了地球上十分之一的已知物种。这部纪录片带领观众深入雨林最深处，见证那些鲜为人知的生命奇迹。</p><p>从色彩斑斓的箭毒蛙到神秘的亚马逊河豚，从巨大的森蚺到微小的切叶蚁，4K超高清镜头捕捉到了每一个令人震撼的细节。影片也毫不回避地展现了森林砍伐和气候变化对这片生态宝库造成的威胁。</p><p>这不仅是一部自然纪录片，更是一封写给地球的情书。</p>',
  },
];

export const getVideosByCategory = (categorySlug: string): VideoItem[] => {
  return videos.filter((v) => v.category === categorySlug);
};

export const getVideoById = (id: string): VideoItem | undefined => {
  return videos.find((v) => v.id === id);
};

export const getRelatedVideos = (currentId: string, category: string, limit: number = 4): VideoItem[] => {
  return videos
    .filter((v) => v.id !== currentId && v.category === category)
    .slice(0, limit);
};

export const getFeaturedVideos = (limit: number = 6): VideoItem[] => {
  return [...videos].sort((a, b) => b.views - a.views).slice(0, limit);
};